module.exports = __webpack_public_path__ + "static/rowIcon4.61700296.svg";